// deps-lint-skip: empty, form, space
import '../../style/index.less';
import './index.less';
